import { render, staticRenderFns } from "./CategoryBarRow.vue?vue&type=template&id=37fdc4cf&scoped=true&"
import script from "./CategoryBarRow.vue?vue&type=script&lang=ts&"
export * from "./CategoryBarRow.vue?vue&type=script&lang=ts&"
import style0 from "./CategoryBarRow.vue?vue&type=style&index=0&id=37fdc4cf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fdc4cf",
  null
  
)

export default component.exports